import { http, HttpResponse } from "msw";
const ONE_GB = 1024 * 1024 * 1024;
const metricGenerators = {
    cpu: ()=>10 + Math.random() * 5,
    mem: ()=>16 * ONE_GB + Math.floor(Math.random() * ONE_GB),
    rx: ()=>60 + Math.floor(Math.random() * 5),
    tx: ()=>5 + Math.floor(Math.random() * 5),
    consumption: ()=>2048 + Math.floor(Math.random() * 256),
    p9999: ()=>8 + Math.random() * 1,
    p999: ()=>6.98 + Math.random() * 0.1,
    p99: ()=>6.83 + Math.random() * 0.15,
    p95: ()=>6.19 + Math.random() * 0.5,
    p50: ()=>1.8 + Math.random() * 2,
    requests_success: ()=>Math.floor(Math.random() * 64),
    requests_failed: ()=>Math.floor(Math.random() * 16)
};
function generateMockMetrics(metric, timespan) {
    const metrics = [];
    const now = Date.now() / 1000;
    const timespanInSeconds = timespan * 60;
    const startTime = now - timespanInSeconds;
    let increment = 1;
    if (timespan > 240) {
        increment = 30;
    }
    for(let i = 0; i < timespan * 60; i += increment){
        const timestamp = startTime + i;
        let value;
        for (const [key, generator] of Object.entries(metricGenerators)){
            if (metric.includes(key)) {
                value = generator();
                break;
            }
        }
        metrics.push([
            timestamp,
            value
        ]);
    }
    return metrics;
}
const handler = http.get("/api/admin/historical-metrics", ({ request })=>{
    const url = new URL(request.url);
    const metric = url.searchParams.get("metric") ?? "";
    const timespan = parseInt(url.searchParams.get("timespan") ?? "60");
    let metrics = generateMockMetrics(metric, timespan);
    if (metrics.length > 3600) {
        const factor = Math.ceil(metrics.length / 3600);
        const downsampled = [];
        for(let i = 0; i < metrics.length; i += factor){
            const chunk = metrics.slice(i, i + factor);
            const avgTimestamp = chunk.reduce((acc, cur)=>acc + cur[0], 0) / chunk.length;
            const avgValue = chunk.reduce((acc, cur)=>acc + cur[1], 0) / chunk.length;
            downsampled.push([
                avgTimestamp,
                avgValue
            ]);
        }
        metrics = downsampled;
    }
    // Convert entire dataset to NDJSON in one go
    const ndjson = metrics.map((m)=>JSON.stringify(m)).join("\n") + "\n";
    const stream = new ReadableStream({
        start (controller) {
            controller.enqueue(new TextEncoder().encode(ndjson));
            controller.close();
        }
    });
    return new HttpResponse(stream, {
        headers: {
            "Content-Type": "application/x-ndjson",
            "Transfer-Encoding": "chunked"
        }
    });
});
export default handler;
